// extracted by mini-css-extract-plugin
export default {"container":"StatusOverlay_container__5NmG3","status":"StatusOverlay_status__VTmmy"};